import { render, staticRenderFns } from "./WageTypes.vue?vue&type=template&id=170ee639&scoped=true&"
import script from "./WageTypes.vue?vue&type=script&lang=js&"
export * from "./WageTypes.vue?vue&type=script&lang=js&"
import style0 from "./WageTypes.vue?vue&type=style&index=0&id=170ee639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170ee639",
  null
  
)

export default component.exports